import { Cake } from "lucide-react";

const MONTHS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août",
  "Septembre", "Octobre", "Novembre", "Décembre"];
const THIS_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: 110 }, (_, i) => THIS_YEAR - 3 - i);
const sel = "h-11 rounded-xl border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40 transition-shadow";

export const ageOf = ({ d, m, y }) => {
  if (!d || !m || !y) return null;
  const now = new Date();
  return now.getFullYear() - y - ((now.getMonth() + 1 < m || (now.getMonth() + 1 === m && now.getDate() < d)) ? 1 : 0);
};

// Jour / Mois / Année : le modèle le plus répandu (Facebook, Google…), molettes natives sur mobile.
export function BirthdatePicker({ value, onChange }) {
  const daysIn = value.m && value.y ? new Date(value.y, value.m, 0).getDate() : 31;
  const set = (k, v) => {
    const next = { ...value, [k]: v ? Number(v) : "" };
    const max = next.m && next.y ? new Date(next.y, next.m, 0).getDate() : 31;
    if (next.d > max) next.d = max;
    onChange(next);
  };
  const age = ageOf(value);
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-[1fr_1.6fr_1.2fr] gap-2">
        <select className={sel} value={value.d} onChange={(e) => set("d", e.target.value)} data-testid="birth-day-select">
          <option value="">Jour</option>
          {Array.from({ length: daysIn }, (_, i) => i + 1).map((d) => <option key={d} value={d}>{d}</option>)}
        </select>
        <select className={sel} value={value.m} onChange={(e) => set("m", e.target.value)} data-testid="birth-month-select">
          <option value="">Mois</option>
          {MONTHS.map((n, i) => <option key={n} value={i + 1}>{n}</option>)}
        </select>
        <select className={sel} value={value.y} onChange={(e) => set("y", e.target.value)} data-testid="birth-year-select">
          <option value="">Année</option>
          {YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      {age !== null ? (
        <p className="flex items-center gap-1.5 text-xs text-primary animate-in fade-in slide-in-from-top-1" data-testid="birth-age-hint">
          <Cake className="w-3.5 h-3.5" /> Vous avez {age} ans{value.d && value.m ? ` · anniversaire le ${value.d} ${MONTHS[value.m - 1].toLowerCase()}` : ""}
        </p>
      ) : null}
    </div>
  );
}
